import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateOrEmDash',
})
export class DateOrEmDashPipe extends DatePipe implements PipeTransform {
  public transform(value: any, format?: string, timezone?: string, locale?: string): string | null {
    if (!value) {
      return '—';
    }
    return super.transform(value, format, timezone, locale);
  }
}
